import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { Input } from '@common-web';
import { forwardRef, useImperativeHandle, useRef } from 'react';

const SaveModalBody = forwardRef(({ handleSave = () => {} }, ref) => {
  const { t } = useTranslation();
  const formikRef = useRef(null);

  const getInitialValues = () => ({
    name: '',
  });

  const getValidationSchema = () =>
    yup.object().shape({
      name: yup.string().required(t('Name is required')),
    });

  useImperativeHandle(
    ref,
    () => ({
      submitForm: () => {
        formikRef.current.submitForm();
      },
    }),
    []
  );

  return (
    <Formik
      initialValues={getInitialValues()}
      validationSchema={getValidationSchema()}
      onSubmit={handleSave}
      innerRef={formikRef}
    >
      {(formikProps) => {
        const { values, setFieldValue, handleSubmit, touched, errors } = formikProps;
        return (
          <form>
            <Input
              placeholder={'Enter Name'}
              name={'name'}
              value={values.name}
              autoFocus={true}
              errorMsg={touched.name && errors.name && errors.name}
              onChange={(e) => setFieldValue('name', e.target.value)}
              onPressEnter={handleSubmit}
            />
          </form>
        );
      }}
    </Formik>
  );
});

export default SaveModalBody;
